<template>
  <a-card :bordered="false">
    <div class="table-page-search-wrapper">
      <a-form
        layout="inline"
        @submit="handleSearch"
        :autoFormCreate="
          (form) => {
            this.searchForm = form;
          }
        "
      >
        <a-row :gutter="48">
          <a-col :md="6" :sm="24">
            <a-form-item label="门店" fieldDecoratorId="branch_id">
              <a-select placeholder="请选择"  allowClear show-search option-filter-prop="children">
                <a-select-option v-for="item in branches" :key="item.id">{{
                  item.name
                }}</a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="24">
            <span class="table-page-search-submitButtons">
              <a-button type="primary" htmlType="submit">查询</a-button>
              <a-divider type="vertical" />
              <a-button type="primary" @click="handleAdd">新增设备</a-button>
            </span>
          </a-col>
        </a-row>
      </a-form>
    </div>
    <div>设备数量：{{ total }}</div>
    <s-table ref="table" size="default" :columns="columns" :data="loadData">
      <template slot="QRCode" slot-scope="text">
        <span><img :src="text" style="width: 124px; height: 124px" /></span>
      </template>
      <span slot="action" slot-scope="text, record">
        <a @click="handleGoDetail(record)">查看数据</a>
        <a-divider type="vertical" />
        <a-popconfirm
          title="确定删除此设备吗？"
          @confirm="handleDelete(record)"
          okText="是"
          cancelText="否"
        >
          <a>删除设备</a>
        </a-popconfirm>
      </span>
    </s-table>
    <a-modal
      :visible="showModal"
      size="middle"
      @cancel="handleClose"
      title="设备管理"
      @ok="handleUpdate"
    >
      <a-form
        :autoFormCreate="
          (form) => {
            this.equipmentForm = form;
          }
        "
      >
        <a-form-item
          label="设备号"
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
        >
          <a-input v-model="equipmentInfo.no" placeholder="请输入设备号" />
        </a-form-item>
        <a-form-item
          label="归属门店"
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
        >
          <a-select placeholder="请选择" v-model="equipmentInfo.branch_id" allowClear show-search option-filter-prop="children">
            <a-select-option v-for="item in branches" :key="item.id">{{
              item.name
            }}</a-select-option>
          </a-select>
        </a-form-item>
      </a-form>
    </a-modal>
  </a-card>
</template>
<script>
import STable from "@/components/table/";
import { getBranchList } from "@/api/branch";
import {
  getEquipmentList,
  updateEquipment,
  deleteEquipment,
  getEquipmentInfo,
} from "@/api/setting/equipment";

export default {
  name: "Equipment",
  components: {
    STable,
  },
  data() {
    return {
      labelCol: {
        span: 5,
      },
      wrapperCol: {
        span: 16,
      },
      total: 0,
      searchForm: null,
      imgForm: {},
      avatar: "",
      queryParam: {}, // 表头
      row: {},
      modalType: "add",
      branches: [],
      branch_id: 0,
      equipmentInfo: {},
      showModal: false,
      equipmentForm: null,
      columns: [
        {
          title: "设备号",
          dataIndex: "no",
        },
        {
          title: "二维码",
          dataIndex: "qrcode_url",
          scopedSlots: { customRender: "QRCode" },
        },
        {
          title: "操作",
          dataIndex: "action",
          scopedSlots: { customRender: "action" },
        },
      ],
      loadData: (params) => {
        return getEquipmentList(Object.assign(params, this.queryParam)).then(
          (res) => {
            this.total = res.count;
            return res;
          }
        );
      },
    };
  },
  created() {
    this.getBranchList();
  },
  computed: {
    hasSelected() {
      return this.selectedRows.length > 0;
    },
  },
  methods: {
    getBranchList: function () {
      getBranchList().then((res) => {
        this.branches = res.list;
      });
    },
    handleSearch(e) {
      e.preventDefault();
      this.queryParam = {
        branch_id: this.searchForm.getFieldValue("branch_id"),
      };
      this.$refs.table.refresh();
    },
    handleAdd() {
      this.equipmentInfo = {};
      this.showModal = true;
      this.modalType = "add";
    },
    handleClose() {
      this.equipmentInfo = {};
      this.showModal = false;
      this.modalType = "add";
    },
    handleUpdate() {
      const vm = this;
      this.equipmentForm.validateFields((err, values) => {
        if (!this.equipmentInfo.no) {
          this.$message.error("请输入设备号");
          return;
        }
        if (!this.equipmentInfo.branch_id) {
          this.$message.error("请选择门店");
          return;
        }
        if (!err) {
          const params = {
            id: this.equipmentInfo.id,
            no: this.equipmentInfo.no,
            branch_id: this.equipmentInfo.branch_id,
          };
          updateEquipment(params).then((res) => {
            this.$message.success("操作成功");
            this.showModal = false;
            this.equipmentInfo = {};
            this.$refs.table.refresh();
          });
        }
      });
    },
    handleDelete(row) {
      deleteEquipment(row.id).then((res) => {
        this.$refs.table.refresh();
        this.$message.success("删除成功");
      });
    },
    // 查看
    handleGoDetail(row) {
      let routertwo = this.$router.resolve({
        name: "EquipmentReadings",
        params: { id: row.id },
      });
      window.open(routertwo.href, "_blank");
    },
  },
};
</script>
<style scoped>
.pic {
  width: 60px;
  height: 60px;
}
.pic > img {
  width: 60px;
  height: 60px;
  display: block;
}
</style>
